import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReportsSatisfactionIssueRoute: InvariantJiraRoute = {
	name: 'servicedesk-reports-satisfaction-time-scale-issue',
	path: '/jira/servicedesk/projects/:projectKey/reports/all-rating/timescale/:timescaleId/:issueKey',
	exact: true,
};
